import { Action } from 'redux';
import UserSession from '../common/user-session';

export const createReducer = <State, ActionHandlers>(initialState: State, actionHandlers: ActionHandlers) => {
  return (state = initialState, action: Action): State =>
    actionHandlers[action.type] 
      ? actionHandlers[action.type](state, action) 
      : state;
};

export const normalizeError = (e: Error) => (e && e.message ? e.message : e);

export const isTimeToRefresh = (prevTime, diff) => {
  return  Date.now() - prevTime > diff;
}

export const tokenIsValid = (expires) => {
  const currentTime = new Date();
  const expireTime = new Date(expires as number);

  if (currentTime < expireTime) {
    return true;
  }

  return false;
}

export const triggerSecureLogout = (reason = 'Token expired or invalid') => {
  try {
    console.log(`Secure logout triggered: ${reason}`);
    
    // Import store and auth actions to avoid circular dependencies
    const { store } = require('@app/store');
    const { actionCreators } = require('@app/common/auth/auth.reducer');
    
    if (store && actionCreators) {
      // Dispatch full logout request to trigger complete cache clearing
      store.dispatch(actionCreators.logoutRequest());

    } else {

      UserSession.clear();
      window.location.href = process.env.REACT_APP_BASE_PATH + '/auth/login' || '/auth/login';
    }
  } catch (error) {

    UserSession.clear();
    window.location.href = process.env.REACT_APP_BASE_PATH + '/auth/login' || '/auth/login';
  }
};